var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComparteContenidoRelevante(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 157.832,
    height: 137.611,
    viewBox: "0 0 157.832 137.611",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:5px;stroke-dasharray:1 12;}.a,.b{stroke:#f0f4f9;stroke-miterlimit:10;}.b{fill:#fdfffc;stroke-width:2px;}.c{fill:#7821a0;}.d{fill:#7f6e5d;}.e{fill:#e6e7e8;}.f{fill:#e4c05c;}.g{fill:#a4c2f7;}.h{fill:#d4e1f4;}.i{fill:#f1eaf4;}.j{fill:#e3e7f2;}.k{fill:#fff;}.l{fill:#264ecc;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 2.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 66.306,
    cy: 66.306,
    r: 66.306,
    transform: "translate(21.721)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 44.585)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 21.721,
    cy: 21.721,
    r: 21.721
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M7.434,13.718a1.43,1.43,0,0,1-1.1-.473L.447,7.2A1.524,1.524,0,0,1,.5,5a1.524,1.524,0,0,1,2.206.052L7.487,9.988,17.574.427a1.561,1.561,0,1,1,2.154,2.259L8.538,13.3A1.806,1.806,0,0,1,7.434,13.718Z",
    transform: "translate(11.432 14.862)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.28 -746.582)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(37.556 782.073)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 8.479,
    cy: 8.479,
    r: 8.479,
    transform: "translate(23.319 5.3)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 3.18,
    cy: 3.18,
    r: 3.18,
    transform: "translate(28.618 9.54)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M87.279,814.723v1.59a8.421,8.421,0,0,0,8.479,0v-1.59a3.967,3.967,0,0,0-4.24-3.625,4.532,4.532,0,0,0-2.989,1.07A3.336,3.336,0,0,0,87.279,814.723Z",
    transform: "translate(-59.72 -795.198)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M44.928,782.893h-.19a6.359,6.359,0,0,0-6.36,6.36v15.9H55.336V782.893Z",
    transform: "translate(-38.377 -782.893)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M50,782.893a6.542,6.542,0,0,1,6.169,6.625v52.732a2.127,2.127,0,0,0,2.12,2.12h31.8a2.126,2.126,0,0,0,2.119-2.12v-53a6.364,6.364,0,0,0-6.36-6.36Z",
    transform: "translate(-43.45 -782.893)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M55.643,782.893a6.542,6.542,0,0,1,6.169,6.625v52.732a2.126,2.126,0,0,0,2.12,2.12H94.67a2.126,2.126,0,0,0,2.12-2.12v-53a6.365,6.365,0,0,0-6.36-6.36Z",
    transform: "translate(-45.913 -782.893)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "i",
    cx: 8.479,
    cy: 8.479,
    r: 8.479,
    transform: "translate(23.319 5.3)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "h",
    cx: 3.18,
    cy: 3.18,
    r: 3.18,
    transform: "translate(28.618 9.54)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(27.559 15.889)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M87.279,814.723v1.59a8.421,8.421,0,0,0,8.479,0v-1.59a3.967,3.967,0,0,0-4.24-3.625,4.532,4.532,0,0,0-2.989,1.07A3.336,3.336,0,0,0,87.279,814.723Z",
    transform: "translate(-87.279 -811.087)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M93.4,833.914v10.6a2.12,2.12,0,0,1-4.24,0v-10.6a2.12,2.12,0,1,1,4.24,0Z",
    transform: "translate(-88.1 -820.125)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M123.181,828.033v19.079l-26.5-5.3v-8.479Z",
    transform: "translate(-91.383 -818.483)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M144.182,824.51v21.2a2.12,2.12,0,0,1-4.24,0v-21.2a2.12,2.12,0,0,1,4.24,0Z",
    transform: "translate(-110.264 -816.021)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M60.844,842.249V787.133a4.253,4.253,0,0,0-4.24-4.24h-3.18c1.166,0,4.24,3.074,4.24,4.24v55.116a2.126,2.126,0,0,0,2.12,2.12h3.18A2.126,2.126,0,0,1,60.844,842.249Z",
    transform: "translate(-44.944 -782.893)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M47.917,782.893h-3.18a6.359,6.359,0,0,0-6.36,6.36v15.9h3.18v-15.9a6.358,6.358,0,0,1,6.36-6.36Z",
    transform: "translate(-38.377 -782.893)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(36.497 781.014)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M59.066,857.025V816.748h2.12v40.277Z",
    transform: "translate(-46.347 -796.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M59.724,873.327a.672.672,0,0,0,.191.063,1.56,1.56,0,0,0,.211.021,1.111,1.111,0,0,0,.753-.307,1.045,1.045,0,0,0-.349-1.728,1.06,1.06,0,0,0-1.156,1.728l.159.127A.83.83,0,0,0,59.724,873.327Z",
    transform: "translate(-46.347 -820.416)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M96.913,803.272a3.182,3.182,0,0,0-3.18,3.18v.205l-4.24.922V788.432h0a7.428,7.428,0,0,0-7.419-7.419H43.916c-.008,0-.016,0-.024.005a7.408,7.408,0,0,0-7.395,7.415v15.9a1.058,1.058,0,0,0,1.06,1.059H49.216V828.71a1.06,1.06,0,1,0,2.12,0V788.7a7.8,7.8,0,0,0-2.341-5.564H82.074a5.306,5.306,0,0,1,5.3,5.3v19.605L71.449,811.5a3.172,3.172,0,0,0-6.334.25h-6.36a1.06,1.06,0,1,0,0,2.12h6.36v3.18h-6.36a1.06,1.06,0,1,0,0,2.12h6.36v3.18h-6.36a1.06,1.06,0,1,0,0,2.12h7.186a3.156,3.156,0,0,0,5.508-1.87l2.145.467v1.966a3.176,3.176,0,0,0,2.494,3.1l5.3,1.175a3.173,3.173,0,0,0,3.868-3.1V825.6l2.12.46v15.367a1.061,1.061,0,0,1-1.06,1.06H52.4a1.061,1.061,0,0,1-1.06-1.06v-4.24a1.06,1.06,0,1,0-2.119,0v4.24a3.183,3.183,0,0,0,3.18,3.18H86.314a3.184,3.184,0,0,0,3.18-3.18V826.523l4.24.922v.205a3.18,3.18,0,0,0,6.36,0v-21.2A3.183,3.183,0,0,0,96.913,803.272ZM49.216,788.7v14.573h-10.6V788.434a5.3,5.3,0,0,1,5.458-5.3A5.484,5.484,0,0,1,49.216,788.7ZM69.355,822.35a1.06,1.06,0,1,1-2.12,0v-10.6a1.06,1.06,0,0,1,2.12,0Zm13.779,3.858a1.056,1.056,0,0,1-.4.829,1.023,1.023,0,0,1-.889.2l-5.293-1.174a1.065,1.065,0,0,1-.841-1.034v-1.5l7.42,1.613Zm-11.659-5.772v-6.77l22.258-4.839v16.447Zm26.5,7.214a1.06,1.06,0,1,1-2.119,0v-21.2a1.06,1.06,0,1,1,2.119,0Z",
    transform: "translate(-36.497 -781.014)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M96.953,799.956a9.539,9.539,0,1,0-9.539,9.539A9.539,9.539,0,0,0,96.953,799.956Zm-12.719,6.693V805.7a2.926,2.926,0,0,1,3.18-2.565,3.467,3.467,0,0,1,2.309.824,2.267,2.267,0,0,1,.871,1.741v.948a7.325,7.325,0,0,1-6.36,0Zm1.06-7.753a2.12,2.12,0,1,1,2.12,2.12A2.121,2.121,0,0,1,85.294,798.9Zm-5.3,1.06A7.42,7.42,0,1,1,92.656,805.2a4.421,4.421,0,0,0-1.555-2.853,5.1,5.1,0,0,0-.669-.481,4.24,4.24,0,1,0-6.04-.006,4.607,4.607,0,0,0-2.22,3.34A7.4,7.4,0,0,1,79.995,799.956Z",
    transform: "translate(-54.557 -785.118)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M75.173,865.888H87.892a1.06,1.06,0,0,0,0-2.12H75.173a1.06,1.06,0,1,0,0,2.12Z",
    transform: "translate(-52.915 -817.133)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M75.173,875.292h21.2a1.06,1.06,0,1,0,0-2.12h-21.2a1.06,1.06,0,1,0,0,2.12Z",
    transform: "translate(-52.915 -821.237)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(65.103 803.272)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M119.079,820.51a3.183,3.183,0,0,0-3.18,3.18v.205l-4.24.922h0l-3,.653-15.043,3.27a3.172,3.172,0,0,0-6.334.25h-.024v2.12h.024v3.18h-.024v2.12h.024v3.18h-.024a3.594,3.594,0,0,0,2.592,3.11,3.139,3.139,0,0,0,3.766-2.861l2.145.467v1.966a3.176,3.176,0,0,0,2.494,3.1l5.3,1.175a3.173,3.173,0,0,0,3.868-3.1v-.606l1.145.248.132.029.843.183h0l4.781,1.04,1.579.344v.205a3.18,3.18,0,0,0,6.36,0v-21.2A3.183,3.183,0,0,0,119.079,820.51ZM91.521,839.588a1.06,1.06,0,0,1-2.12,0v-10.6a1.06,1.06,0,0,1,2.12,0Zm13.779,3.858a1.054,1.054,0,0,1-.4.829,1.024,1.024,0,0,1-.89.2L98.722,843.3a1.065,1.065,0,0,1-.841-1.034v-1.5l7.419,1.613Zm10.6-.934-22.258-4.839V830.9l22.258-4.839Zm4.24,2.375a1.06,1.06,0,1,1-2.12,0v-21.2a1.06,1.06,0,0,1,2.12,0Z",
    transform: "translate(-87.257 -820.51)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComparteContenidoRelevante);
export default __webpack_public_path__ + "static/media/comparte_contenido_relevante.29b2dbfdf097d6c9e9f880dddabeb13f.svg";
export { ForwardRef as ReactComponent };